import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const clickTarget = find(`.${componentPrefix}clicktarget`, el)
  const hasClickClass = el.classList.contains(`${componentPrefix}clickcollect`)

  if (hasClickClass) {
    el.addEventListener('click', event => {
      if (event.target.tagName === 'A') {
        return
      }

      if (event.target === clickTarget) {
        return
      }

      const evt = document.createEvent('MouseEvent')
      evt.initEvent('click', true, true)
      clickTarget.dispatchEvent(evt)
      return false
    })
  }
}

register('teaserCard', component)
